import React, { Component, useState, createRef } from "react";
import "../index.scss";

export default function Sticker({ title, subTitle }) {
  if (!title) return null;
  else if (title === "") return null;
  else if (title === "0") return null;

  return (
    <div className="sticker-container">
      <h2>{title}</h2>
      <p>{subTitle}</p>
      <div className="right-circle"></div>
      <div className="left-circle"></div>
    </div>
  );
}
